var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWikiIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3044_1502)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 20.2818V5.84H2V19.2818H9.05169C9.81705 19.2818 10.4642 19.4264 11 19.6763V8.39821H13V22.84C13 23.3923 12.5523 23.84 12 23.84C11.4477 23.84 11 23.3923 11 22.84C11 22.5927 10.9156 22.1932 10.6591 21.8769C10.4372 21.6033 10.0003 21.2818 9.05169 21.2818H1C0.447715 21.2818 0 20.8341 0 20.2818Z",
    fill: "#6C74B4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 1.84C0 1.28771 0.447715 0.839996 1 0.839996H9.05169C10.5298 0.839996 11.567 1.37925 12.2126 2.17553C12.8236 2.92912 13 3.80874 13 4.39821V18.84C13 19.3923 12.5523 19.84 12 19.84C11.4477 19.84 11 19.3923 11 18.84C11 18.5927 10.9156 18.1932 10.6591 17.8769C10.4372 17.6033 10.0003 17.2818 9.05169 17.2818H1C0.447715 17.2818 0 16.8341 0 16.2818V1.84ZM11 15.6764V4.39821C11 4.15092 10.9156 3.75143 10.6591 3.43511C10.4372 3.16147 10.0003 2.84 9.05169 2.84H2V15.2818H9.05169C9.81705 15.2818 10.4642 15.4264 11 15.6764Z",
    fill: "#6C74B4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 1.84C24 1.28771 23.5523 0.839996 23 0.839996H14.9483C13.4702 0.839996 12.433 1.37925 11.7874 2.17553C11.1764 2.92912 11 3.80874 11 4.39821V18.84C11 19.3923 11.4477 19.84 12 19.84C12.5523 19.84 13 19.3923 13 18.84C13 18.5927 13.0844 18.1932 13.3409 17.8769C13.5628 17.6033 13.9997 17.2818 14.9483 17.2818H23C23.5523 17.2818 24 16.8341 24 16.2818V1.84ZM13 15.6764V4.39821C13 4.15092 13.0844 3.75143 13.3409 3.43511C13.5628 3.16147 13.9997 2.84 14.9483 2.84H22V15.2818H14.9483C14.1829 15.2818 13.5358 15.4264 13 15.6764Z",
    fill: "#6C74B4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 20.2818V5.84H22V19.2818H14.9483C13.4702 19.2818 12.433 19.821 11.7874 20.6173C11.1764 21.3709 11 22.2505 11 22.84H13C13 22.5927 13.0844 22.1932 13.3409 21.8769C13.5628 21.6033 13.9997 21.2818 14.9483 21.2818H23C23.5523 21.2818 24 20.8341 24 20.2818Z",
    fill: "#6C74B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3044_1502"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWikiIcon);
export default __webpack_public_path__ + "static/media/wiki-icon.0143fe46e20176f4bc98deff034ef512.svg";
export { ForwardRef as ReactComponent };